import React from 'react';
import { Backdrop, Button, CircularProgress } from '@mui/material';
import isotipoDark from '../../assets/isotipo_dark_secondary.svg';

type BancameBackdropProps = {
  openBackdrop: boolean;
  loadingText?: string|React.ReactElement,
  type?: 'loading' | 'error',
  errorRedirectURL?: string
  customLogo?: string | null,
}
const defaultProps = {
  loadingText: 'Un momento...',
  type: 'loading',
  errorRedirectURL: '/account',
  customLogo: undefined,
};
export default function BancameBackdrop(props: BancameBackdropProps) {
  const {
    openBackdrop,
    loadingText,
    type,
    errorRedirectURL = defaultProps.errorRedirectURL,
    customLogo = defaultProps.customLogo,
  } = props;
  const handleErrorReditect = () => {
    window.location.href = errorRedirectURL;
  };
  return (
    <Backdrop
      sx={{
        backgroundColor: 'rgba(245, 245, 245, 0.9)',
        textAlign: 'center',
      }}
      open={openBackdrop}
    >
      <div>
        <div>
          <object
            data={customLogo === null ? undefined : customLogo ?? isotipoDark}
            width="60px"
            aria-labelledby="AvatarExcited"
          />
        </div>
        <div>
          {' '}
          <b style={{ marginLeft: 10 }}>
            {type === 'loading' ? loadingText : (
              <>
                <div>¡Ha ocurrido un error!</div>
                {' '}
                <div>Por favor inténtalo de nuevo o contáctanos si este error persiste</div>
                <br />
                <Button
                  variant="contained"
                  onClick={handleErrorReditect}
                >
                  Reintentar

                </Button>
              </>
            )}
          </b>

        </div>
        <br />
        {type === 'loading'
          && (
            <CircularProgress
              color="inherit"
            />
          )}

      </div>

    </Backdrop>
  );
}

BancameBackdrop.defaultProps = defaultProps;
